module.exports = __webpack_public_path__ + "media/images/login_as_icon-8eb0229987f45b0b4d4837231394e449.gif";